var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 26C6.5 34.171 6.5 42.5898 9.35571 45.1283C12.2114 47.6667 16.8076 47.6667 26 47.6667C35.1924 47.6667 39.7886 47.6667 42.6443 45.1283C45.5 42.5898 45.5 34.171 45.5 26",
    stroke: "#513117",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7627 30.771L44.7785 26.8662C46.0687 26.4791 46.7139 26.2856 47.1232 25.8217C47.203 25.7314 47.275 25.6345 47.3387 25.5322C47.6654 25.0068 47.6654 24.3332 47.6654 22.9862C47.6654 17.6775 47.6654 15.0232 46.2072 13.2311C45.927 12.8867 45.6122 12.5719 45.2677 12.2916C43.4757 10.8335 40.8214 10.8335 35.5127 10.8335H16.4847C11.176 10.8335 8.52171 10.8335 6.72965 12.2916C6.38522 12.5719 6.07041 12.8867 5.79016 13.2311C4.33203 15.0232 4.33203 17.6775 4.33203 22.9862C4.33203 24.3332 4.33203 25.0068 4.65871 25.5322C4.72235 25.6345 4.79442 25.7314 4.87416 25.8217C5.28352 26.2856 5.92865 26.4791 7.21891 26.8662L20.2347 30.771",
    stroke: "#513117",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.082 10.8335C15.8662 10.7883 17.6771 9.65246 18.2842 7.97419C18.3028 7.92256 18.322 7.86513 18.3603 7.75028L18.4159 7.5835C18.5073 7.30929 18.553 7.17213 18.6019 7.0505C19.2263 5.49726 20.6895 4.44262 22.3605 4.34142C22.4914 4.3335 22.6359 4.3335 22.925 4.3335H29.0734C29.3625 4.3335 29.507 4.3335 29.6379 4.34142C31.3088 4.44262 32.7721 5.49726 33.3965 7.0505C33.4454 7.17214 33.4911 7.30926 33.5825 7.5835L33.6381 7.75028C33.6762 7.86446 33.6956 7.92272 33.7142 7.97419C34.3213 9.65246 36.1312 10.7883 37.9154 10.8335",
    stroke: "#513117",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.332 27.0835H21.6654C21.0671 27.0835 20.582 27.5685 20.582 28.1668V32.85C20.582 33.293 20.8517 33.6914 21.263 33.8559L22.78 34.4627C24.8462 35.2892 27.1512 35.2892 29.2174 34.4627L30.7344 33.8559C31.1457 33.6914 31.4154 33.293 31.4154 32.85V28.1668C31.4154 27.5685 30.9303 27.0835 30.332 27.0835Z",
    stroke: "#513117",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCase);
export default __webpack_public_path__ + "static/media/case.916c4ce5494f070cf4c5d5d740b8a910.svg";
export { ForwardRef as ReactComponent };